<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <div>
        {{ 'COMMON.ORDER_DETAILS.ATTACHMENTS' | translate }}
      </div>
      <div class="edit-button" *ngIf="!editingDisabled">
        <button mat-button color="primary" (click)="onClickAdd()">
          + {{ 'COMMON.ORDER_DETAILS.UPLOAD_ATTACHMENTS' | translate }}
        </button>
      </div>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div *ngIf="files && files.length > 0; else noFiles">
      <glxy-uploader-list [files]="files" (fileDeleted)="onFileDeleted($event)"></glxy-uploader-list>
    </div>
    <ng-template #noFiles>
      <div class="no-files">
        {{ 'COMMON.ORDER_DETAILS.EMPTY_ATTACHMENTS' | translate }}
      </div>
    </ng-template>
  </mat-card-content>
</mat-card>
